import useFetch from '../../../hooks/useFetch';
import { useContext, useState } from 'react';
import { ServiceEvents } from '../shared/interfaces';
import { EndPoints } from '../EndPoints';
import {
    WarehouseOrderDataForm,
    WarehouseOrderFilters
} from '../../models/WarehouseOrder';
import { QuoteFilters } from '../../models/Quote';
import { fetchDefaultHeaders } from '../shared/vars';
import { AppContext } from '../../../contexts/AppContext';

const useWarehouseOrderService = () => {
    const { doPost, doGet, doPut, doDelete } = useFetch();
    const { showLoading, hideLoading, changeAnimation } = useContext(AppContext);

    const [fetchingGetWarehouseOrders, setFetchingGetWarehouseOrders] = useState(false);
    const [fetchingCreateWarehouseOrder, setFetchingCreateWarehouseOrder] =
        useState(false);
    const [fetchingStoreWarehouseOrder, setFetchingStoreWarehouseOrder] = useState(false);
    const [fetchingEditWarehouseOrder, setFetchingEditWarehouseOrder] = useState(false);
    const [fetchingCanEditWarehouseOrder, setFetchingCanEditWarehouseOrder] = useState(false);
    const [fetchingUpdateWarehouseOrder, setFetchingUpdateWarehouseOrder] =
        useState(false);
    const [fetchingDeleteWarehouseOrder, setFetchingDeleteWarehouseOrder] =
        useState(false);
    const [fetchingShowWarehouseOrder, setFetchingShowWarehouseOrder] = useState(false);

    const [fetchingShowQuoteWarehouseOrder, setFetchingShowQuoteWarehouseOrder] =
        useState(false);

    const [fetchingCanChangeStatusWarehouseOrder, setFetchingCanChangeStatusWarehouseOrder] = useState(false);
    const [fetchingChangeStatusWarehouseOrder, setFetchingChangeStatusWarehouseOrder] = useState(false);
    const [fetchingChangeStatusToActiveWarehouseOrder, setFetchingChangeStatusToActiveWarehouseOrder] = useState(false);
    const [fetchingChangeStatusToFinishWarehouseOrder, setFetchingChangeStatusToFinishWarehouseOrder] = useState(false);
    const [fetchingChangeStatusToAnnulledWarehouseOrder, setFetchingChangeStatusToAnnulledWarehouseOrder] = useState(false);
    

    const getWarehouseOrders = (
        warehouseOrderFilters: WarehouseOrderFilters,
        events: ServiceEvents = {}
    ) => {
        const queryString = Object.entries(warehouseOrderFilters)
            .map(([key, value]) => `${key}=${value}`)
            .join('&');
        const url = `${EndPoints.WAREHOUSE_ORDERS.GET_WAREHOUSE_ORDERS}?${queryString}`;
        doGet({
            ...events,
            url: url,
            setFetching: setFetchingGetWarehouseOrders
        });
    };

    const createWarehouseOrder = (events: ServiceEvents = {}) => {
        doGet({
            ...events,
            url: EndPoints.WAREHOUSE_ORDERS.CREATE_WAREHOUSE_ORDER,
            setFetching: setFetchingCreateWarehouseOrder
        });
    };

    const storeWarehouseOrder = (
        quoteDataForm: WarehouseOrderDataForm,
        events: ServiceEvents = {}
    ) => {
        doPost({
            ...events,
            url: EndPoints.WAREHOUSE_ORDERS.STORE_WAREHOUSE_ORDER,
            body: quoteDataForm,
            setFetching: setFetchingStoreWarehouseOrder
        });
    };

    const editWarehouseOrder = (id: number, events: ServiceEvents = {}) => {
        doGet({
            ...events,
            url: EndPoints.WAREHOUSE_ORDERS.EDIT_WAREHOUSE_ORDER.replace(
                ':id',
                id.toString()
            ),
            setFetching: setFetchingEditWarehouseOrder
        });
    };

    const canEditWarehouseOrder = (events: ServiceEvents = {}) => {
        doGet({
            ...events,
            url: EndPoints.TRANSPORTATION_ORDERS.CAN_EDIT_TRANSPORTATION_ORDER,
            setFetching: setFetchingCanEditWarehouseOrder
        });
    };

    const updateWarehouseOrder = (
        id: number,
        quoteDataFrom: WarehouseOrderDataForm,
        events: ServiceEvents = {}
    ) => {
        doPut({
            ...events,
            url: EndPoints.TRANSPORTATION_ORDERS.UPDATE_TRANSPORTATION_ORDER.replace(
                ':id',
                id.toString()
            ),
            body: quoteDataFrom,
            setFetching: setFetchingUpdateWarehouseOrder
        });
    };

    const updateWarehouseOrderRateRunner = (
        id: number,
        quoteDataFrom: WarehouseOrderDataForm,
        events: ServiceEvents = {}
    ) => {
        doPut({
            ...events,
            url: EndPoints.TRANSPORTATION_ORDERS.UPDATE_TRANSPORTATION_ORDER_RATE_RUNNER.replace(
                ':id',
                id.toString()
            ),
            body: quoteDataFrom,
            setFetching: setFetchingUpdateWarehouseOrder
        });
    };

    const showWarehouseOrder = (id: number, events: ServiceEvents = {}) => {
        doGet({
            ...events,
            url: EndPoints.TRANSPORTATION_ORDERS.SHOW_TRANSPORTATION_ORDER.replace(
                ':id',
                id.toString()
            ),
            setFetching: setFetchingShowWarehouseOrder
        });
    };

    const deleteWarehouseOrder = (id: number, events: ServiceEvents = {}) => {
        doDelete({
            ...events,
            url: EndPoints.WAREHOUSE_ORDERS.DELETE_WAREHOUSE_ORDER.replace(
                ':id',
                id.toString()
            ),
            setFetching: setFetchingDeleteWarehouseOrder
        });
    };

    const showQuoteWarehouseOrder = (id: number, events: ServiceEvents = {}) => {
        doGet({
            ...events,
            url: EndPoints.WAREHOUSE_ORDERS.SHOW_QUOTE_WAREHOUSE_ORDER.replace(
                ':id',
                id.toString()
            ),
            setFetching: setFetchingShowQuoteWarehouseOrder
        });
    };

    const getExcelAllWarehouseOrders = (
        WarehouseOrderFilters: WarehouseOrderFilters,
        events: ServiceEvents = {}
    ) => {
        if (showLoading) showLoading('download', 'descargando archivo...');

        let url = new URL(EndPoints.WAREHOUSE_ORDERS.GET_EXCEL_WAREHOUSE_ORDERS);
        url = getUrlWarehouseOrderFilters(
            url,
            WarehouseOrderFilters.warehouse_order_status,
            WarehouseOrderFilters.start_date,
            WarehouseOrderFilters.end_date,
            WarehouseOrderFilters.warehouse_order_id,
            WarehouseOrderFilters.client,
            WarehouseOrderFilters.quote_id
        );

        fetch(url.href, { headers: { ...fetchDefaultHeaders } })
            .then((response) => {
                response
                    .blob()
                    .then((blob) => {
                        const a = document.createElement('a');
                        const url = window.URL.createObjectURL(blob);
                        a.href = url;
                        a.download = 'pedidos.xlsx';
                        a.click();
                        window.URL.revokeObjectURL(url);
                        if (changeAnimation)
                            changeAnimation('downloadSuccess', 'descarga exitosa', true);
                    })
                    .catch((error) => {
                        if (changeAnimation) changeAnimation('error', 'descarga fallida', true);
                    });
            })
            .catch((error) => {
                if (changeAnimation) changeAnimation('error', 'descarga fallida', true);
            });
    };

    const getUrlWarehouseOrderFilters = (
        url: URL,
        transportation_order_status: string | null = null,
        start_date: string | null = null,
        end_date: string | null = null,
        transportation_order_id: number | null = null,
        client: string | null = null,
        quote_id: number | null = null
    ) => {
        if (transportation_order_status && transportation_order_status !== 'TODOS') {
            url.searchParams.append('status', transportation_order_status);
        }
        if (start_date) {
            url.searchParams.append('start_date', start_date);
        }
        if (end_date) {
            url.searchParams.append('end_date', end_date);
        }
        if (transportation_order_id) {
            url.searchParams.append('id', String(transportation_order_id));
        }
        if (client) {
            url.searchParams.append('client', String(client));
        }
        if (quote_id) {
            url.searchParams.append('quote', String(quote_id));
        }
        return url;
    };

    const canChangeStatusWarehouseOrder = (id: number, status: string, events: ServiceEvents = {}) => {
        doGet({
            ...events,
            url: EndPoints.WAREHOUSE_ORDERS.CAN_CHANGE_WAREHOUSE_ORDER.replace(
                ':id',
                id.toString()
            ).replace(':status', status),
            setFetching: setFetchingCanChangeStatusWarehouseOrder
        });
    };

    const changeStatusWarehouseOrder = (id: number, status: string, events: ServiceEvents = {}) => {
        doPut({
            ...events,
            url: EndPoints.WAREHOUSE_ORDERS.CHANGE_STATUS_WAREHOUSE_ORDER.replace(
                ':id',
                id.toString()
            ),
            body: { status: status },
            setFetching: setFetchingChangeStatusWarehouseOrder
        });
    };

    const changeStatusToActiveWarehouseOrder = (id: number, status: string, events: ServiceEvents = {}) => {
        doPut({
            ...events,
            url: EndPoints.WAREHOUSE_ORDERS.CHANGE_STATUS_TO_ACTIVE_WAREHOUSE_ORDER.replace(
                ':id',
                id.toString()
            ),
            body: { status: status },
            setFetching: setFetchingChangeStatusToActiveWarehouseOrder
        });
    };

    const changeStatusToFinishWarehouseOrder = (id: number, status: string, events: ServiceEvents = {}) => {
        doPut({
            ...events,
            url: EndPoints.WAREHOUSE_ORDERS.CHANGE_STATUS_TO_FINISH_WAREHOUSE_ORDER.replace(
                ':id',
                id.toString()
            ),
            body: { status: status },
            setFetching: setFetchingChangeStatusToFinishWarehouseOrder
        });
    };

    const changeStatusToAnnulledWarehouseOrder = (id: number, status: string, events: ServiceEvents = {}) => {
        doPut({
            ...events,
            url: EndPoints.WAREHOUSE_ORDERS.CHANGE_STATUS_TO_ANNULLED_WAREHOUSE_ORDER.replace(
                ':id',
                id.toString()
            ),
            body: { status: status },
            setFetching: setFetchingChangeStatusToAnnulledWarehouseOrder
        });
    };


    return {
        fetchingGetWarehouseOrders,
        fetchingDeleteWarehouseOrder,
        fetchingCreateWarehouseOrder,
        fetchingStoreWarehouseOrder,
        fetchingEditWarehouseOrder,
        fetchingCanEditWarehouseOrder,
        fetchingUpdateWarehouseOrder,
        fetchingShowWarehouseOrder,
        fetchingShowQuoteWarehouseOrder,
        fetchingCanChangeStatusWarehouseOrder,
        fetchingChangeStatusWarehouseOrder,
        fetchingChangeStatusToActiveWarehouseOrder,
        fetchingChangeStatusToFinishWarehouseOrder,
        fetchingChangeStatusToAnnulledWarehouseOrder,
        getWarehouseOrders,
        createWarehouseOrder,
        updateWarehouseOrderRateRunner,
        storeWarehouseOrder,
        editWarehouseOrder,
        canEditWarehouseOrder,
        updateWarehouseOrder,
        deleteWarehouseOrder,
        showWarehouseOrder,
        showQuoteWarehouseOrder,
        // getExcelAllWarehouseOrders,
        canChangeStatusWarehouseOrder,
        changeStatusWarehouseOrder,
        changeStatusToActiveWarehouseOrder,
        changeStatusToFinishWarehouseOrder,
        changeStatusToAnnulledWarehouseOrder
    };
};

export default useWarehouseOrderService;
